import { Button, Paper, Stack, Text } from '@mantine/core'
import { IconChevronRight } from '@tabler/icons-react'
import Link from 'next/link'
import { type FC, type ReactNode } from 'react'

export interface HomeCardProps {
  children: ReactNode
  external?: boolean
  href?: string
  onClick?: () => void
  title: string
}

export const HomeCard: FC<HomeCardProps> = ({ children, external = false, href, onClick, title }) => (
  <Paper
    display='flex'
    p='lg'
  >
    <Stack
      align='center'
      justify='space-between'
      w='100%'
    >
      <Text
        color='navy'
        weight='bold'
      >
        {title}
      </Text>
      <Text
        align='center'
        size='sm'
      >
        {children}
      </Text>
      <Button
        color='navy'
        // @ts-ignore
        component={external || onClick ? 'a' : Link}
        href={href}
        onClick={onClick}
        rightIcon={<IconChevronRight size={16} />}
        target={external ? '_blank' : undefined}
        title={title}
      >
        {title}
      </Button>
    </Stack>
  </Paper>
)
